<template>
    <transition name="modal">
        <div class="rightPanel" v-if="isVisible" :style="{ height: IsEmbedded ? 'calc(100vh - 40px)' : 'calc(100vh - 47px)' }">
            
            <div class="header-v2">
                 <div class="header-content">
                    <slot name="header">
                        default header
                    </slot>
                 </div>
                <div class="buttons">
                    <img width="24" src="../../../public/icons/workflow/close.svg" class="theme-svg" id="close-v2" @click="$emit('close')" />
                </div>
            </div>

            <div class="body content">
                <slot name="body">
                    default body
                </slot>
            </div>

            <div class="footer">
                <slot name="footer">
                    <div class="panelButtons">
                        <CommonButton
                            :type="ButtonType.Primary"
                            :text="Localizer.Localize('Ok_PascalCase')"
                            @click="$emit('close')"/>
                    </div>
                </slot>
            </div>

            <slot name="modal">
            </slot>
        </div>
    </transition>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import { Localizer } from '../../api/Localizer';
    import CommonButton from './CommonButton.vue';
    import { ButtonType } from './HelpersInterface';

    import { isEmbedded } from '@/utils/Utils';

    @Component({ components: { CommonButton } })
    export default class RightPanel extends Vue {
        private Localizer = new Localizer(this.$store);

        public isVisible = false;
        private ButtonType = ButtonType;


        get IsEmbedded(): boolean {
            return isEmbedded();
        }

        mounted() {
            // Assign isVisible true on mounted as part of vue3 migration
            // Transition root https://v3-migration.vuejs.org/breaking-changes/transition-as-root.html
            this.isVisible = true;
        }
    }
</script>

<style scoped>

    .rightPanel .header-v2 {
        display: flex;
        justify-content: space-between;
        gap: 8px;
    }   
    .rightPanel .header-v2 :deep(.title) {
        font-size: 22px;
        font-weight: bold;
    }
    .rightPanel .header-v2 .buttons {
        display: flex;
        align-items: start;
    }

    .rightPanel .body {
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 21px;
        justify-items: stretch;
        align-items: start;
    }

        .rightPanel .body :deep(.bodyContents) {
            display: grid;
            grid-template-columns: auto 1fr;
            grid-column-gap: 21px;
            grid-row-gap: 21px;
            justify-items: stretch;
            align-items: baseline;
            padding-right: 12px;
        }

            .rightPanel .body :deep(.bodyContents .title) {
                font-size: 14px;
                color: var(--accent-color);
                text-transform: uppercase;
                grid-column-start: 1;
                grid-column-end: 3;
            }
            .rightPanel .body :deep(.bodyContents label) {
                font-weight: bold;
                margin-bottom: 0;
            }

            .rightPanel .body :deep(.bodyContents .checkbox) {
                align-self: end;
            }

    .rightPanel .footer {
        justify-content: center;
    }

        .rightPanel .footer .panelButtons, .rightPanel .footer :deep(.panelButtons) {
            display: flex;
            justify-content: center;
            gap: 16px;
        }
</style>
